import { useRef, forwardRef } from "react";
import BSModal from "react-bootstrap/Modal";

export const Modal = forwardRef(({ show, onHide, children, ...props }, ref) => {
  const modalRef = useRef(null);

  return (
    <BSModal ref={ref || modalRef} show={show} onHide={onHide} {...props}>
      <div className="h-100">
        <div className="d-lg-none position-absolute end-0 top-0 mt-3 me-3">
          <button
            className="btn btn-transparent icon m-auto mb-2"
            onClick={onHide}
          >
            <i className="bi bi-x-lg text-secondary fs-4"></i>
          </button>
        </div>

        {children}
      </div>
    </BSModal>
  );
});

Modal.displayName = "Modal";

// Re-export Modal sub-components for easy access
Modal.Header = BSModal.Header;
Modal.Title = BSModal.Title;
Modal.Body = BSModal.Body;
Modal.Footer = BSModal.Footer;
